/*global addParam, ob1.Ob1Component, newEvent*/
document.addEventListener("DOMContentLoaded", function () {
    "use strict";

    const addressResults = new Map();

    const domCache = {
        searchField: document.getElementById("search-field-1"),
        errorLabels: Array.from(document.querySelectorAll("label.invalid-feedback[for=search-field-1]")),
        addressStreetNumber: document.getElementById("address-street-number"),
        addressStreetLetter: document.getElementById("address-street-letter"),
        addressStreetType: document.getElementById("address-street-type"),
        addressStreetName: document.getElementById("address-street-name"),
        addressStreetCode: document.getElementById("address-street-code"),
        addressPostalCode: document.getElementById("address-postal-code"),
        addressCityName: document.getElementById("address-city-name"),
        addressCityCode: document.getElementById("address-city-code"),
        addressLine: document.getElementById("address-line"),
        addressOrasId: document.getElementById("address-oras-id"),
        addressCoordinateX: document.getElementById("address-coordinate-x"),
        addressCoordinateY: document.getElementById("address-coordinate-y")
    };

    const read = (field) => field && field.trim() || "";

    const readLocality = function (address) {
        if (domCache.searchField.dataset.enableLocality !== "true") {
            return "";
        }
        const locality = read(address.locality);
        return locality && ("(" + locality + ")");
    };

    const addressToString = function (address) {
        return String.join(", ", [
            String.join(" ", [
                read(address.streetNumber),
                read(address.streetNumberExtension),
                read(address.streetType),
                read(address.streetName)
            ]),
            String.join(" ", [
                read(address.postalCode),
                readLocality(address),
                read(address.cityName)
            ])
        ]);
    };

    const onSearchFieldInput = (function () {

        const clearResultFields = function () {
            domCache.searchField.setCustomValidity("");
            domCache.errorLabels.forEach((label) => label.hidden = true);
            domCache.addressStreetNumber.value = "";
            domCache.addressStreetLetter.value = "";
            domCache.addressStreetType.value = "";
            domCache.addressStreetName.value = "";
            domCache.addressStreetCode.value = "";
            domCache.addressPostalCode.value = "";
            domCache.addressCityName.value = "";
            domCache.addressCityCode.value = "";
            domCache.addressLine.value = "";
            domCache.addressOrasId.value = "";
            domCache.addressCoordinateX.value = "";
            domCache.addressCoordinateY.value = "";
        };

        const queryAddresses = function () {
            const retrieveUrl = domCache.searchField.dataset.retrieveUrl;
            const searchInput = domCache.searchField.value.trim();
            if (searchInput.length >= 3) {
                const url = addParam(retrieveUrl, "address=" + encodeURIComponent(searchInput));
                return (new MshRequest()).get(url);
            } else {
                addressResults.clear();
                return Promise.resolve([]);
            }
        };

        const processResults = function (addressArray) {
            const ob1SearchField = ob1.Ob1Component.get(domCache.searchField).SearchField;
            ob1SearchField.repository = addressArray.reduce(function (accumulator, address) {
                const addressStr = addressToString(address);
                accumulator.push(addressStr);
                addressResults.set(addressStr, address);
                return accumulator;
            }, []);
            ob1SearchField.refreshSearchFieldResults(event);
            domCache.searchField.classList.remove("is-invalid");
            domCache.searchField.dispatchEvent(newEvent("ob1-searchfield-results-update"));
        };

        let timeout = undefined;

        const onStreakEnd = function () {
            timeout = undefined;
            queryAddresses().then(processResults);
        };

        return function () {
            const isStreakBeginning = timeout === undefined;
            clearTimeout(timeout);
            timeout = setTimeout(onStreakEnd, 300);
            if (isStreakBeginning) {
                clearResultFields();
            }
        };
    }());

    const onResultSelected = function () {
        const selectedAddress = addressResults.get(domCache.searchField.value);
        if (selectedAddress !== undefined) {
            domCache.addressStreetNumber.value = selectedAddress.streetNumber;
            domCache.addressStreetLetter.value = selectedAddress.streetNumberExtension;
            domCache.addressStreetType.value = selectedAddress.streetType;
            domCache.addressStreetName.value = selectedAddress.streetName;
            domCache.addressStreetCode.value = selectedAddress.streetCode;
            domCache.addressPostalCode.value = selectedAddress.postalCode;
            domCache.addressCityName.value = selectedAddress.cityName;
            domCache.addressCityCode.value = selectedAddress.cityCode;
            domCache.addressOrasId .value = selectedAddress.id;
            if (selectedAddress.geographicCoordinates) {
                domCache.addressCoordinateX.value = selectedAddress.geographicCoordinates.x;
                domCache.addressCoordinateY.value = selectedAddress.geographicCoordinates.y;
            }

            domCache.addressLine.value = selectedAddress.streetLine;
            domCache.searchField.setCustomValidity("");
            domCache.errorLabels.forEach((label) => label.hidden = true);
            domCache.searchField.dispatchEvent(newEvent("ob1-searchfield-result-validated"));
        }
    };

    if (domCache.searchField !== null) {
        domCache.searchField.addEventListener("input", onSearchFieldInput);
        domCache.searchField.addEventListener("ob1-searchfield-result-selected", onResultSelected);

        (function hackOb1() {
            const intervalId = setInterval(function () {
                const ob1Components = ob1.Ob1Component.get(domCache.searchField);
                const ob1SearchField = ob1Components && ob1Components.SearchField;
                if (ob1SearchField) {
                    const originalAddSeletedResult = ob1SearchField.addSeletedResult;
                    ob1SearchField.addSeletedResult = function (resultLine) {
                        originalAddSeletedResult.call(ob1SearchField, resultLine);
                        domCache.searchField.dispatchEvent(newEvent("ob1-searchfield-result-selected"));
                    };
                    clearInterval(intervalId);
                }
            }, 100);
        }());

        document.getElementById("search-field-results").addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();// empêche la sélection d'un résultat par la touche entrée sur la liste
                // de faire partir un formulaire de la page
            }
        });
    }
});

// Compatibilité IE11 : je mets ces deux props après la déclaration du listener, ainsi, même s'ils
// échouent, le code on DOMContentLoaded pourra s'exécuter

// variable globale laissée intentionnellement pour l'initialisation du composant SearchField
window.adressesRepository = [];

// variable globale dépréciée laissée intentionnellement pour empêcher un bug dans OB1
try {
    window.event = {};
} catch (e) {
    // la propriété n'est pas définie dans IE11 mais pourtant
    // lève une erreur quand on essaie de l'assigner
}
